export const AUTHENTICATED_GUEST_SMART_ASSISTANT_ID = 'authenticatedGuestSmartAssistantId';
